document.addEventListener("DOMContentLoaded", () => {
document.body.addEventListener("click", (e) => {
  const btn = e.target.closest(".product-info-svg");
  if (!btn) return;

  const allBtns = [...document.querySelectorAll(".product-info-svg")];
  const index = allBtns.indexOf(btn);

  const drawers = document.querySelectorAll(".product-info-drawer");
  const overlays = document.querySelectorAll(".drawer-overlay");
  const closeBtns = document.querySelectorAll(".drawer-close");

  const drawer = drawers[index];
  const overlay = overlays[index];
  const closeBtn = closeBtns[index];

  if (!drawer || !overlay || !closeBtn) return;

  // 🔹 Get current variant ID
  const variantIdElement = document.querySelector('[data-product-variants]');
  const currentVariantId = variantIdElement ? variantIdElement.getAttribute('data-current-variant-id') : null;

  // 🔹 Show correct SVG content based on variant
  const drawerContent = drawer.querySelector('.drawer-content');
  if (drawerContent) {
    const allSvgContents = drawerContent.querySelectorAll('.drawer-svg-content');
    
    // Hide all contents first
    allSvgContents.forEach(content => {
      content.style.display = 'none';
    });

    // Show variant-specific content if exists, otherwise show product-level fallback
    let contentShown = false;
    if (currentVariantId) {
      const variantContent = drawerContent.querySelector(`[data-variant-id="${currentVariantId}"]`);
      if (variantContent) {
        variantContent.style.display = 'block';
        contentShown = true;
      }
    }

    // If no variant content found, show product-level fallback
    if (!contentShown) {
      const fallbackContent = drawerContent.querySelector('[data-product-svg="true"]');
      if (fallbackContent) {
        fallbackContent.style.display = 'block';
      }
    }
  }

  // 🔹 Open drawer
  drawer.classList.add("open");
  overlay.classList.add("active");
  document.body.classList.add("no-scroll");

  // 🔹 Close drawer (via close icon or overlay)
  const closeDrawer = () => {
    drawer.classList.remove("open");
    overlay.classList.remove("active");
    document.body.classList.remove("no-scroll");
  };

  closeBtn.addEventListener("click", closeDrawer);
  overlay.addEventListener("click", closeDrawer);
});

// 🔹 Listen for variant changes and update the data-current-variant-id
document.addEventListener("product:variant-change", function (evt) {
  if (evt.detail && evt.detail.variant) {
    const variantIdElement = document.querySelector('[data-product-variants]');
    if (variantIdElement) {
      variantIdElement.setAttribute('data-current-variant-id', evt.detail.variant.id);
    }
    
    updateProductBenefits(evt.detail.variant.id);
  }
});

function updateProductBenefits(variantId) {
  const container = document.querySelector('[data-product-benefits-container]');
  const content = document.querySelector('[data-product-benefits-content]');
  
  if (!container || !content) return;
  
  const dataElement = document.querySelector('[id^="ProductBenefitsData-"]');
  if (!dataElement) return;
  
  let data;
  try {
    data = JSON.parse(dataElement.textContent);
  } catch (e) {
    console.error('Benefits data parse error:', e);
    return;
  }
  
  let benefits = null;
  
  if (data.variantBenefits[variantId] && data.variantBenefits[variantId].length > 0) {
    benefits = data.variantBenefits[variantId];
  } else if (data.productBenefits && data.productBenefits.length > 0) {
    benefits = data.productBenefits;
  }
  
  if (benefits) {
    content.innerHTML = benefits.map(b => `<p class="paragraph-xs">${b}</p>`).join('');
    container.style.display = '';
  } else {
    container.style.display = 'none';
  }
}


setInterval(function() {
  var timers = document.querySelectorAll('.countdown-timer');
  timers.forEach(function(el) {
    if (!el.timerActive && el.dataset.targetDate) {
      el.timerActive = true;
      var targetDate = new Date(el.dataset.targetDate).getTime();
      
      function updateCountdown() {
        var now = new Date().getTime();
        var distance = targetDate - now;
        if (distance < 0) {
          el.innerHTML = "00:00:00";
          return;
        }
        
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        el.innerHTML =
          (days > 0 ? days + " : " : '') +
          (hours < 10 ? "0" + hours : hours) + " : " +
          (minutes < 10 ? "0" + minutes : minutes) + " : " +
          (seconds < 10 ? "0" + seconds : seconds);
      }
      
      updateCountdown();
      setInterval(updateCountdown, 1000);
    }
  });
}, 2000);


  function updatePrices() {
    const checkedRadio = document.querySelector('.js_change_qty:checked');
    if (!checkedRadio) return; 

    var dataPriceElement = document.querySelector('[data-price]');
    var dataComparePriceElement = document.querySelector('[data-compare-price]');

    const baseCurrentPrice = Number(dataPriceElement.getAttribute('data-original_price')) / 100;
    const baseOriginalPrice = Number(dataComparePriceElement.getAttribute('data-original_c_price')) / 100;
    
    const quantity = parseInt(checkedRadio.value, 10) || 1;
    const discountAttribute = parseInt(checkedRadio.getAttribute('data_discount')) || 0;
    const discount = discountAttribute / 100;

    const finalCurrentPrice = (baseCurrentPrice * quantity) - discount;
    const finalOriginalPrice = baseOriginalPrice * quantity;

    dataPriceElement.textContent = window.formatMoney(finalCurrentPrice*100, '${{amount_no_decimals_with_comma_separator}}').replace(',00','');
    dataComparePriceElement.textContent = window.formatMoney(finalOriginalPrice*100, '${{amount_no_decimals_with_comma_separator}}').replace(',00','');
    document.querySelectorAll('[name="quantity"]').forEach(qty => {
        qty.value = quantity;
    });
}

document.addEventListener('change', function (e) {
  if (e.target.classList.contains('js_change_qty')) {
    updatePrices.call(e.target, e);
  }
});



window.addEventListener("load", () => {
  requestAnimationFrame(() => {
    const selectedBtn = document.querySelector('[dynamic-variant-button].selected');
    if (selectedBtn) {
      selectedBtn.click();
      
    } else {
      
    }
  });

  setTimeout(function(){
  const checkedInput = document.querySelector('.js_change_qty:checked');
    if (checkedInput) {
      checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
 },2000);   

});


document.body.addEventListener('click', function(e) {
  const question = e.target.closest('.facets_questions');
  if (!question) return;
  
  e.preventDefault();

  const answer = question.nextElementSibling;
  const svg = question.querySelector('.facets-label svg');

  if (answer && answer.classList.contains('facets_answers')) {
    const isVisible = answer.style.display === 'flex' || answer.offsetHeight > 0;

    if (isVisible) {
      // Slide up - CLOSING (arrow should point DOWN)
      if (svg) {
        svg.style.transform = 'rotate(0deg)';
        svg.style.transition = 'transform 0.2s ease';
      }
      answer.style.maxHeight = answer.scrollHeight + 'rem';
      requestAnimationFrame(() => {
        answer.style.transition = 'max-height 0.2s ease';
        answer.style.maxHeight = '0';
      });

      requestAnimationFrame(() => {
        answer.style.display = 'none';
      });
      // setTimeout(() => {
      //   answer.style.display = 'none';  
      // }, 200);
    } else {
      // Slide down - OPENING (arrow should point RIGHT)
      if (svg) {
        svg.style.transform = 'rotate(-90deg)';
        svg.style.transition = 'transform 0.2s ease';
      }
      answer.style.display = 'flex';
      answer.style.overflow = 'hidden';
      answer.style.maxHeight = '0';
      requestAnimationFrame(() => {
        answer.style.transition = 'max-height 0.2s ease';
        answer.style.maxHeight = answer.scrollHeight + 'rem';
      });
    }
  }

  const closestDetails = question.closest('details');
  
});



});

// Inject Heading above Review Widget
var renderCount = 0;
const interval = setInterval(() => {
  if (renderCount > 20) {
    clearInterval(interval);
  }

  renderCount++;
  if (document.getElementById('judgeme_product_reviews')) {
    injectHeading();
    clearInterval(interval);
    
  }
}, 1000);

// Function to check and inject heading
function injectHeading() {
  
  const targetId = 'judgeme_product_reviews';
  const widget = document.getElementById(targetId);
  if (!widget) return false;

  var judgeMeReviewHeading = document.getElementById('judge_me_review_heading');

  console.log('judgeMeReviewHeading: ' + judgeMeReviewHeading);
  if (!judgeMeReviewHeading) return false;
  var judgeMeReviewHeadingValue = judgeMeReviewHeading.value?.trim();

  console.log('judgeMeReviewHeadingValue: ' + judgeMeReviewHeadingValue);
  if (judgeMeReviewHeadingValue == '') return false;

  const reviewContainer = widget.querySelector('.jdgm-rev-widg__reviews');
  const reviewItems = reviewContainer ? reviewContainer.querySelectorAll('.jdgm-rev') : [];
  
  if (reviewItems.length > 0 && !widget.querySelector('.reviews-heading')) {
    const headingWrapper = document.createElement('div');
    headingWrapper.className = 'judgeme-reviews-heading h3';

    // match anything inside brackets: [ ... ]
    const match = judgeMeReviewHeadingValue.match(/\[(.*?)\]/);

    if (match) {
      const content = match[1]; // text inside []

      // Replace ONLY the bracketed part, nothing else
      headingWrapper.innerHTML = judgeMeReviewHeadingValue.replace(
        /\[.*?\]/,
        `<font-miller class="h3-accent">${content}</font-miller>`
      );
    } else {
      // No brackets → keep original text 100% untouched
      headingWrapper.textContent = judgeMeReviewHeadingValue;
    }

    // headingWrapper.innerHTML = `<font-miller class="h3-accent">50.000</font-miller> zufriedenen Kundenbewertungen`;
    widget.insertBefore(headingWrapper, widget.firstChild);
    
    return true;
  }
  return false;
}

// Auto reinit countdown when HTML refreshes
setInterval(function() {
  if (document.querySelectorAll('.countdown-timer').length > 0) {
    document.querySelectorAll('.countdown-timer').forEach(el => el.timerActive = false);
  }
}, 1500);


